"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = exports.QuantityUom = void 0;
var QuantityUom;
(function (QuantityUom) {
    QuantityUom["EACH"] = "EACH";
    QuantityUom["CASE"] = "CASE";
})(QuantityUom || (exports.QuantityUom = QuantityUom = {}));
/**
 * @description Source of the order creation entity which directly called replenishment
 */
var Source;
(function (Source) {
    Source["SELLER_PORTAL"] = "SELLER_PORTAL";
    Source["RSIP"] = "RSIP";
    Source["WHOLESALE_INTEGRATIONS"] = "WHOLESALE_INTEGRATIONS";
    Source["PUBLIC_API"] = "PUBLIC_API";
    Source["WHOLESALE_MIGRATION"] = "WHOLESALE_MIGRATION";
    Source["CHANNELS_WORKFLOW"] = "CHANNELS_WORKFLOW";
})(Source || (exports.Source = Source = {}));
//# sourceMappingURL=CreateOrderRequest.js.map